/** localStorage key for the path to restore after Auth0 redirects back. */
export const AUTH_RETURN_KEY = 'rialtic-auth-return'

/** localStorage key for the Auth0 error query params surfaced on /auth/status. */
export const AUTH_ERROR_KEY = 'rialtic-auth-error'
